(function () {
  const header = document.querySelector('.site-header');
  const toggle = document.querySelector('.nav-toggle');
  const links = document.querySelector('.nav-links');
  const overlay = document.querySelector('.nav-overlay');

  function setNav(open) {
    if (!links || !toggle) return;
    links.classList.toggle('open', open);
    overlay?.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  toggle?.addEventListener('click', () => {
    setNav(!links.classList.contains('open'));
  });

  overlay?.addEventListener('click', () => setNav(false));

  links?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setNav(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setNav(false);
  });

  window.addEventListener('scroll', () => {
    header?.classList.toggle('header-scrolled', window.scrollY > 12);
  }, { passive: true });

  document.querySelectorAll('[data-address-delete]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!window.confirm('Delete this address?')) return;
      const token = document.querySelector('input[name="authenticity_token"]');
      const form = document.createElement('form');
      form.method = 'post';
      form.action = button.getAttribute('data-address-delete');
      const method = document.createElement('input');
      method.type = 'hidden';
      method.name = '_method';
      method.value = 'delete';
      form.appendChild(method);
      if (token) form.appendChild(token.cloneNode());
      document.body.appendChild(form);
      form.submit();
    });
  });

  const ready = document.querySelector('[data-plan-ready="true"]');
  const url = ready?.getAttribute('data-plan-url');
  if (url) {
    const link = document.createElement('a');
    link.href = url;
    link.download = 'how-to-gym-arm-workout-plan.pdf';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
})();
